import { Directive, HostListener, NgModule } from '@angular/core';

@Directive({
  selector: '[preventDefault]'
})
export class PreventDefaultDirective {

  @HostListener("click", ["$event"])
  public onClick(event: any): void {
    event.preventDefault();
    event.stopPropagation();
  }

}

@NgModule({
  declarations: [
    PreventDefaultDirective
  ],
  imports: [],
  exports: [
    PreventDefaultDirective
  ]
})
export class PreventDefaultDirectiveModule { }
